<h1 mat-dialog-title class="d-flex justify-content-between align-items-center">
  Processar por Período
  <button mat-button mat-dialog-close type="button" class="close" data-dismiss="modal" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</h1>

<mat-divider></mat-divider>

<mat-card class="mt-3">
  <mat-card-content>
    <form [formGroup]="form">
      <div class="col-md-12">
        <div class="row align-items-center justify-content-between">
          <div class="col-md-2 d-flex">
            <lib-datepicker-day [schema]="dataInicioProcessamento" class="mr-3"></lib-datepicker-day>
            <lib-datepicker-day [schema]="dataFimProcessamento"></lib-datepicker-day>
          </div>

          <div class="col-md-2 d-flex justify-content-end">
            <button
              id="btn-processar-periodo"
              mat-raised-button
              class="maps-button"
              color="primary"
              [disabled]="!formValid"
              [matMenuTriggerFor]="ProcessarPeriodo"
            >
              <div class="maps-button__spinner">
                <mat-spinner class="me-2" diameter="20" *ngIf="isLoading"></mat-spinner>
                <span>Confirmar Processamento <i class="fa-solid fas fa-caret-down ms-2"></i></span>
                <span *ngIf="isLoading">Processando...</span>
              </div>
            </button>

            <mat-menu #ProcessarPeriodo="matMenu">
              <button
                id="btn-processar-selecionadas"
                mat-menu-item
                (click)="processarSelecionadas()"
                [disabled]="this.data.processamentosSelecionados.length === 0"
              >
                Processar Selecionadas
              </button>

              <button
                mat-menu-item
                (click)="processarTodas()"
                id="btn-processar-todas"
                [disabled]="this.data.processamentosSelecionados.length > 0"
              >
                Processar Todas
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>

<div *ngIf="this.data.processamentosSelecionados.length > 0" class="mat-elevation-z2 mt-3">
  <app-processamento-periodo-selecionadas-table [processamentosSelecionados]="this.data.processamentosSelecionados">
  </app-processamento-periodo-selecionadas-table>
</div>
